import { useCookies } from "react-cookie";
import { SessionDataContext } from "../contexts";

export default function SessionDataProvider({ children }) {
	const [cookies, setCookie] = useCookies();
	const set = (key, value) => setCookie(key, value);
	const drawerOpen = cookies.drawerOpen == true ? true : false;
	const drawerSelected = cookies.drawerSelected;
	const filterStudentIds = cookies.filterStudentIds ? cookies.filterStudentIds : [];
	const filterSubjectIds = cookies.filterSubjectIds ? cookies.filterSubjectIds : [];
	const filterCourseIds = cookies.filterCourseIds ? cookies.filterCourseIds : [];
	const filterTermIds = cookies.filterTermIds ? cookies.filterTermIds : [];
	const filterStatuses = cookies.filterStatuses ? cookies.filterStatuses : [];
	const hideInactive = cookies.hideInactive ? cookies.hideInactive : false;

	return (
		<SessionDataContext.Provider value={{ set, drawerOpen, drawerSelected, filterStudentIds, filterSubjectIds, filterCourseIds, filterTermIds, filterStatuses, hideInactive }}>
			{children}
		</SessionDataContext.Provider>
	);
}